/* jshint node:true */
  'use strict';

  var Stream = function (_Transform) {
    throw new Error("jsonexport called without third argument as a callback and is required")
  }

  module.exports = Stream;
  


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonexport/dist/core/stream.js
// module id = 955
// module chunks = 0